// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--3qtZ3l_DD"};